export const NAME_MAX_LENGTH = 255;

const isUnset = (s) => !s.date || !s.start || !s.end;

const SESSION_CHECKS = [
  [(s) => s.name.trim() === "", "Every session needs a name."],
  [(s) => s.name.trim().length > NAME_MAX_LENGTH, `Session names can be up to ${NAME_MAX_LENGTH} characters.`],
  [isUnset, "Every session needs a date, start, and end time."],
  [(s) => s.start === s.end, "A session's end time must be different from its start time."],
];

export function scheduleProblemDetails(form, sessions) {
  if (!form.venue_ownership_id) return { message: "Pick a venue for this class.", field: "class-venue" };
  if (sessions.length === 0) return { message: "Add at least one session.", field: "add-session" };
  for (let i = 0; i < SESSION_CHECKS.length; i += 1) {
    const [failing, message] = SESSION_CHECKS[i];
    const session = sessions.find(failing);
    if (session) return { message, field: `session-${session.key}` };
  }
  return null;
}

export default function scheduleProblem(form, sessions) {
  return scheduleProblemDetails(form, sessions)?.message || null;
}

export function unsetSessionCount(sessions) {
  return sessions.filter(isUnset).length;
}

export function unsetSessionsMessage(count) {
  if (count === 0) return null;
  return count === 1
    ? "1 session doesn't have a date and time yet. Set it, or remove it, to continue."
    : `${count} sessions don't have a date and time yet. Set them, or remove them, to continue.`;
}
